<div class="modal-overlay">
  <div class="modal-content">
    <div class="modal-title-bar">
      <h2>Editar Perfil</h2>
    </div>

    <label>Nombre:</label>
    <input [(ngModel)]="editedUser.name" />

    <label>Apellidos:</label>
    <input [(ngModel)]="editedUser.lastName" />

    <label>Correo:</label>
    <input [(ngModel)]="editedUser.email" />

    <label>Teléfono:</label>
    <input [(ngModel)]="editedUser.phone" />

    <div class="actions">
      <button class="btn-cancel" (click)="closeModal()">Cancelar</button>
      <button class="btn-save" (click)="saveChanges()">Guardar</button>
    </div>
  </div>
</div>
